import {CONFIG} from "../../config";
import axios from "axios";

async function GetSensorsQuery(device_id) {
    const location = CONFIG.API_URL + "statistics/sensors/" + device_id;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };

    try {
        return await axios.get(location, settings);
    } catch (e) {
        return e;
    }
}

export default GetSensorsQuery;